
// Scans page for any element with data-datetime attribute and
// replaces the element text with a localized datetime.
// The format of the data-datetime attribute should be yyyyMMddThh:mm:ss.
//
// Example <span data-datetime="20200611T09:00:00">Fallback time to be replaced goes here.</span>
//
( function() {
  let dates = document.querySelectorAll( "[data-datetime]" );
  let validDateString = /\d{8}T\d{2}:\d{2}:\d{2}/;
  let options = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZoneName: "short"
  };
  for ( let i = 0; i < dates.length; i++ ) {
    let d = dates[ i ];
    let utc = d.getAttribute( "data-datetime" );
    if ( utc.match( validDateString ) ) {
      let utcDate = new Date( Date.UTC(
          parseInt( utc.substr( 0, 4 ) ),
          parseInt( utc.substr( 4, 2 ) ) - 1, // JavaScript month is 0-based
          parseInt( utc.substr( 6, 2 ) ),
          parseInt( utc.substr( 9, 2 ) ),
          parseInt( utc.substr( 12, 2 ) ),
          parseInt( utc.substr( 15, 2 ) )
      ) );
      d.innerHTML = new Intl.DateTimeFormat( "default", options ).format( utcDate );
    } else {
      console.log( "Element has data-datetime attr, but the format is incorrect: " + utc +
          ". Expecting yyyyMMddThh:mm:ss" );
    }
  }
})();
